import React, { memo } from 'react'

import { CloseTagFilled, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const MODELS = [
  {
    key: 'quad',
    labelKey: 'viewerSidebar.enhance.segment.unavailable.quad',
    image: '/assets/three_d_studio/segment_tab/quad_models.webp',
  },
  {
    key: 'rigged',
    labelKey: 'viewerSidebar.enhance.segment.unavailable.rigged',
    image: '/assets/three_d_studio/segment_tab/rigged_models.webp',
  },
]

function UnavailableModels() {
  const t = useTranslation()

  return (
    <div className="segment-tab__unavailable">
      <p className="segment-tab__unavailable-title cgt-caption-semibold">
        {t('viewerSidebar.enhance.segment.unavailable.title')}
      </p>
      <ul className="segment-tab__unavailable-list">
        {MODELS.map(({ key, labelKey, image }) => (
          <li key={key} className="segment-tab__unavailable-item">
            <div className="segment-tab__unavailable-card">
              <img
                className="segment-tab__unavailable-image"
                src={image}
                alt=""
                aria-hidden="true"
              />
              <Icon
                svgComponent={CloseTagFilled}
                className="segment-tab__unavailable-badge"
                aria-hidden="true"
              />
            </div>
            <span className="segment-tab__unavailable-label cgt-caption-semibold">{t(labelKey)}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default memo(UnavailableModels)
